import { createSelector } from 'reselect';
import PredesComplianceIncorrectLocationCodeUsageDetailsColumns
  from '../../containers/PredesComplianceIncorrectLocationCodeUsageDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceIncorrectLocationCodeUsageDetailsColumns);
